import { useTranslation } from 'react-i18next';
import { FileDropzone } from '@/components';

interface FileUploadFieldProps {
  file: File | null;
  onFileSelect: (file: File | null) => void;
  disabled?: boolean;
}

export function FileUploadField({
  file,
  onFileSelect,
  disabled = false,
}: FileUploadFieldProps) {
  const { t } = useTranslation();

  return (
    <FileDropzone
      file={file}
      onFileSelect={onFileSelect}
      disabled={disabled}
      prompt={t('firmware.sidePanel.dropFile')}
    />
  );
}
